import { createI18n } from 'vue-i18n';
import { getLocale } from '@/utils/locale';
import { slavicPluralization } from '@/utils/slavicPluralization';

const messages = {
  ru: {
    orgDoesNotExist: 'Организация не существует',
    linkIsNotValid: 'Ссылка не действительна',
    controllerNotFound: 'Контроллер не найден',
    controllerLoadError: 'Произошла ошибка, повторите позже',
  },
  en: {
    orgDoesNotExist: 'Organization does not exist',
    linkIsNotValid: 'Link is not valid',
    controllerNotFound: 'Controller not found',
    controllerLoadError: 'An error occurred, please try again later',
  },
};

export const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  pluralRules: {
    ru: slavicPluralization,
  },
  messages,
});
